import React, { useCallback } from 'react';
import DefaultMsgPage from 'components/DefaultMsgPage';
import { useHistory } from 'react-router-dom';

const ResentedEmail: React.FC = () => {
  const history = useHistory();

  const handleRedirect = useCallback(async () => {
    history.push('/validar?resendEmail=true');
  }, []);

  return <DefaultMsgPage traductionKey="resented_email_error" image="brokenSuitcase" onPrimary={handleRedirect} />;
};

export default ResentedEmail;
